import $ from "jquery";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import Swal from "sweetalert2/dist/sweetalert2.js";
import CartHead from "./components/CartHead.vue";
import CartPage from "./components/CartPage.vue";
import CartCheckout from "./components/CartCheckout.vue";
import CheckoutPaypal from "./paypal.js";
import { loadScript } from "@paypal/paypal-js";
import PromisePonyfill from "promise-polyfill";
import Product from "./product";
import AmazonCartCheckout from "./components/AmazonCartCheckout";

const HeadCart = divId => {
    if (divId == "summary") {
        Vue.use(VueGoogleMaps, {
            load: {
                key: "AIzaSyBtZ68jL6KzuY4WIzg2Bk2z9TzUb6qdZvs",
                libraries: "places"
            }
        });
    }

    const cartVue = new Vue({
        el: "#" + divId,
        data: {
            apiStatus: true,
            currency: null,
            items: null,
            countryNameLoc: null,
            scalapay: null,
            logged: window.PlUs.lg,
            api: window.PlUs.api,
            cart: window.Store.cart,
            address: window.Store.address,
            userDontHaveAddress: false,
            addressEmpty: {
                id: null,
                name: null,
                surname: null,
                company_name: null,
                address: null,
                telephone: null,
                formatted_address: null,
                zip_code: null,
                city: null,
                district: null
            },
            checkout: window.Store.checkout,
            strings: window.PlUs.strings,
            lang: window.PlUs.lang,
            countryRestriction: {
                GB: 135
            },
            allPayments: null,
            debug: process.env.NODE_ENV === "development",
            empty: null,
            isOpen: false,
            loading: false,
            loadingPage: false,
            enableBuy: true,
            shippingRu: false,
            isCheckout: false,
            payments: [],
            scalapayObject: document.getElementsByTagName("scalapay-widget")[0],
            paymentButton: "",
            list_valid: null
        },
        components: {
            "head-cart": CartHead,
            "page-cart": CartPage,
            "checkout-cart": CartCheckout,
            "amazon-cart-checkout": AmazonCartCheckout
        },
        watch: {
            isOpen: function(val) {
                if (val) {
                    $(document).unbind("click");
                    $("body").addClass("no-scroll");
                    $("#algolia-section").hide();
                    $(".deliver-list").removeClass("open");
                    const _this = this;
                    setTimeout(() => {
                        $(document).on("click", function(e) {
                            if (
                                $(e.target).closest(".head-cart").length === 0
                            ) {
                                _this.isOpen = false;
                                $(document).unbind("click");
                            }
                        });
                    }, 50);
                } else {
                    $("body").removeClass("no-scroll");
                    $(".header-dropdown").removeClass("opened");
                    $(".deliver-list").removeClass("open");
                    $("#algolia-section").hide();
                }
            },
            "cart.country.iso": function(val) {
                this.checkMinOrder(val);
                this.checkValidPayment(
                    this.cart.list_valid,
                    this.cart.country.id
                );
                // Auto-rimozione gift card se paese diverso dall'Italia
                if (val !== 'IT' && this.cart.promoCode && this.cart.promoCode.startsWith('GIFT-')) {
                    this.deletePromo();
                    Swal.fire({
                        icon: 'warning',
                        title: window.PlUs.strings['attention'] || 'Attenzione',
                        text: window.PlUs.strings['giftcard_country_error'] || 'La Gift Card è utilizzabile solo per acquisti con destinazione Italia.',
                    });
                }
            },
            "cart.totalItems": function(val) {
                if (val) {
                    $(".cart-quantity")
                        .addClass("on")
                        .text(val);
                } else {
                    $(".cart-quantity").removeClass("on");
                }
                this.empty = val == 0;
            },
            "cart.list_valid": function(val) {
                this.checkValidPayment(val, this.cart.country.id);
            },
            "address.same": function(val) {
                if (this.isCheckout) {
                    if (!val) {
                        this.address.alternativeChecked = false;
                    }
                }
            },
            "address.alternativeChecked": function(val) {
                if (val == false) {
                    this.address.alternative = {
                        name: "",
                        surname: "",
                        company_name: "",
                        address: "",
                        zip_code: "",
                        district: "",
                        city: "",
                        country: "",
                        telephone: ""
                    };
                } else {
                    const countryInvoice = this.address.list.find(
                        element => element.id == this.checkout.paymentAddress
                    );
                    console.log(
                        "@countryInvoice",
                        countryInvoice,
                        this.address.alternative
                    );
                    if (
                        countryInvoice.country.iso_code !=
                        this.address.alternative.country
                    ) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.strings["errror_shipping_nation"]
                        });
                        this.address.same = false;
                    }
                }
            },
            "scalapayObject.shadowRoot": function(val) {
                if (this.debug) {
                    console.log(
                        "@calapayObject.shadowRoot",
                        document.getElementsByTagName("scalapay-widget"),
                        val
                    );
                }
                if (val != null) {
                    if (this.debug) {
                        console.log(
                            "@calapayObject.shadowRoot",
                            document.getElementsByTagName("scalapay-widget"),
                            val
                        );
                    }
                    document.getElementsByTagName(
                        "scalapay-widget"
                    )[0].shadowRoot.children[1].style = "display: block";
                }
            }
        },
        methods: {
            /**
             * Se scalapay non è attivo lo spegne dalla lista dei pagamenti
             */
            async checkValidPayment(val, country) {
                if (this.debug) {
                    console.log(
                        "@checkValidPayment",
                        "async",
                        val,
                        this.isCheckout,
                        this.allPayments
                    );
                }
                if (this.isCheckout) {
                    let tmpPayment = [];
                    this.allPayments.forEach(method => {
                        if (val.includes(method.id)) {
                            tmpPayment.push(method);
                        }
                    });
                    this.payments = tmpPayment;
                    this.checkout.paymentMethod = null;
                    await this.changeMethodPayment(null);
                }
            },
            async removeItem(key, currency) {
                this.loadingPage = true;
                await window.Store.removeItem(key, currency);
                this.checkMinOrder();
                this.loadingPage = false;
            },
            async updateItem(key, action) {
                this.loadingPage = true;
                await window.Store.updateItem(key, action);
                this.loadingPage = false;
            },
            async addItem(skuId, price, currency, productId, calltoaction) {
                this.loadingPage = true;
                await window.Store.addItem(
                    skuId,
                    price,
                    currency,
                    productId,
                    calltoaction
                );
                this.checkMinOrder();
                this.loadingPage = false;
            },
            async addPromo(promo) {
                this.loadingPage = true;
                await window.Store.addPromo(promo);
                this.checkMinOrder();
                this.loadingPage = false;
            },
            async deletePromo() {
                this.loadingPage = true;
                await window.Store.deletePromo();
                this.checkMinOrder();
                this.loadingPage = false;
            },
            async setAddress(val) {
                this.loadingPage = true;
                await window.Store.setAddress(val);
                window.location.reload();
                this.cart = window.Store.cart;
                this.loadingPage = false;
            },
            async setAddressShipping() {
                this.loadingPage = true;
                await window.Store.setShippingAddress();
                this.cart = window.Store.cart;
                this.loadingPage = false;
            },
            async setMethodPayment(id) {
                this.loadingPage = true;
                await window.Store.setMethodPayment(id);
                this.loadingPage = false;
            },
            async removeMethodPayment(id) {
                this.loadingPage = true;
                await window.Store.removeMethodPayment(id);
                this.loadingPage = false;
            },
            async changeMethodPayment(id) {
                this.loadingPage = true;
                await window.Store.changeMethodPayment(id);
                this.loadingPage = false;
                // GA4
                this.gaCheckout(id);
            },
            changeNewAddress() {
                this.address.list = [];
            },
            checkMinOrder(val) {
                if (!val) {
                    val = this.cart.country.iso;
                }
                if (val != "GB") {
                    this.enableBuy = true;
                } else if (
                    val == "GB" &&
                    this.cart.subtotal > this.countryRestriction.GB
                ) {
                    this.enableBuy = true;
                } else {
                    this.enableBuy = false;
                }
                if (val == "RU") {
                    this.shippingRu = true;
                }
            },
            /**
             *
             * Setta a true la variabile alternativeChecked che abilita i
             * blocchi grafici che riportano i dati di spedizione che
             * differiscono da quelli di fatturazione
             */
            async setNewAddress() {
                if (this.debug) {
                    console.log(
                        "@setNewAddress",
                        this.addressEmpty,
                        this.address.list
                    );
                }
                this.address.list.push(this.addressEmpty);
                await this.createAddress(this.address.list[0]);
                if (this.apiStatus) {
                    document.querySelector(".summary__loading").style.display =
                        "block";
                    await this.setAddress(this.address.list[0].id);
                    window.location.reload();
                }
            },
            /**
             *
             * Setta a true la variabile alternativeChecked che abilita i
             * blocchi grafici che riportano i dati di spedizione che
             * differiscono da quelli di fatturazione
             */
            setAlternativeChecked() {
                if (this.debug) {
                    console.log("@setAlternativeChecked");
                }
                this.address.alternativeChecked = true;
            },
            /**
             * Mostra il div del carrello nel header del sito
             */
            open() {
                if (this.debug) {
                    console.log("@open");
                }
                this.isOpen = true;
            },
            /**
             * Nascode il div del carrello nel header del sito
             */
            close() {
                if (this.debug) {
                    console.log("@close");
                }
                this.isOpen = false;
            },
            /**
             * Converte il value di UPPARCASE
             * @param {*} e
             */
            upper(e) {
                e.target.value = e.target.value.toUpperCase();
            },
            /**
             * Crea un nuovo indirizzo
             * @param {Object} address
             */
            async createAddress(address) {
                this.apiStatus = false;
                return window.axios
                    .post(window.PlUs.api.address, address)
                    .then(response => {
                        if (this.debug) {
                            console.log("@createAddress", response, address);
                        }
                        if (!response.data.data.status) {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response.data.data.message
                            });
                        } else {
                            this.apiStatus = true;
                            this.address.list = response.data.data.address;
                        }
                    })
                    .catch(function(error) {
                        console.error(error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: error
                        });
                        this.loading = false;
                    });
            },
            /**
             * Crea un nuovo indirizzo
             * @param {Object} address
             */
            async getPaymentBytton() {
                let dataInvoice = null;
                if (this.address.sameInvoice) {
                    dataInvoice = {
                        companyName: this.address.companyName,
                        taxCode: this.address.taxCode,
                        vatNumber: this.address.vatNumber,
                        pecEmail: this.address.pecEmail,
                        sdi: this.address.sdi
                    };
                }
                return window.axios
                    .post(window.PlUs.api.checkout_button, {
                        note: this.address.note,
                        invoice: dataInvoice,
                        sameinvoice: this.address.sameInvoice
                    })
                    .then(response => {
                        const _this = this;
                        if (this.debug) {
                            console.log(
                                "@getPaymentBytton",
                                response,
                                response.data.data
                            );
                        }
                        this.paymentButton = response.data.data.paybutton;

                        // aggiorno i dati su analytis
                        let productVersioIds = [];
                        const items = this.cart.items;
                        for (const product of items) {
                            productVersioIds.push(
                                product.attributes.product_version_code
                            );
                        }
                        if (process.env.NODE_ENV == "production") {
                            gtag("event", "conversion", {
                                send_to: "AW-795664375/JZztCIfymYoBEPe_s_sC",
                                value: this.cart.total,
                                currency: this.cart.currency,
                                transaction_id: response.data.data.orderCode,
                                dynx_itemid: productVersioIds,
                                dynx_totalvalue: this.cart.total
                            });
                        }
                        setTimeout(function() {
                            document.getElementById("paybytton").click();
                        }, 2000);
                    })
                    .catch(function(error) {
                        console.error(error);
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: error
                        });
                        this.loading = false;
                    });
            },
            gaCheckout(paymentId) {
                let products = [];
                this.cart.items.forEach(element => {
                    let totaldiscount = 0;
                    totaldiscount =
                        element["attributes"].discount > 0
                            ? element["attributes"].price_original -
                              element["attributes"].price
                            : 0;

                    products.push({
                        name: element["ga4"].name,
                        id: element["product_version"],
                        price: element["attributes"].price,
                        brand: "Pollini",
                        category: element["ga4"].category,
                        category2: element["ga4"].category2,
                        category3: element["ga4"].category3,
                        category4: element["ga4"].category4,
                        category5: element["ga4"].category5,
                        variant:
                            element["ga4"].color +
                            "|" +
                            element["attributes"].size,
                        quantity: element["quantity"],
                        full_price: element["attributes"].price_original,
                        discount: totaldiscount,
                        discount_rate: element["attributes"].discount
                    });
                });

                let payment = null;
                this.payments.forEach(element => {
                    if (element.id == paymentId) {
                        payment = element.label;
                    }
                });
                if (this.debug) {
                    console.log(payment);
                }
                if (payment != null) {
                    //GA4 checkout step3
                    window.dataLayer.push({
                        event: "checkout",
                        eventCategory: "Ecommerce",
                        eventAction: "Checkout",
                        eventID: window.EventTrackingPageId,
                        "x-fb-ck-fbc": window.fbc_cookie,
                        "x-fb-ck-fbp": window.fbp_cookie,
                        ecommerce: {
                            checkout: {
                                actionField: {
                                    step: 3,
                                    option: payment
                                },
                                products: products
                            }
                        }
                    });
                }
            },
            /**
             * Crea il pagamento tramite le API
             */
            async goTopayment() {
                if (this.debug) {
                    console.log("@goTopayment", this.checkout.paymentMethod);
                }
                this.loadingPage = true;
                // se l'utente non ha indirizzi nella sua rubrica salvo il suo indirizzo come primario
                if (this.userDontHaveAddress) {
                    await this.createAddress(this.address.list[0]);
                    this.setAddress(this.address.list[0].id);
                }
                // Se l'utente inserisce un indirizzo di spedizione lo creao
                if (this.address.alternativeChecked) {
                    await this.setAddressShipping();
                }
                await this.getPaymentBytton();
                this.checkout.showPaymantButton = true;
                this.loadingPage = false;
            }
        },
        async created() {
            if (this.debug) {
                console.log("@created", window.PlUs.checkout);
            }
            this.loading = true;
            if (this.cart.country.iso == "RU") {
                this.shippingRu = true;
            }
            if (window.PlUs.checkout) {
                this.isCheckout = true;
                this.address.countries = window.PlUs.countries;
                this.address.list = window.PlUs.address;
                this.allPayments = window.PlUs.payments;
            }
            if (this.debug) {
                console.log("@created@", "async");
            }
            await window.Store.getCart();
            this.checkMinOrder();
            if (this.isCheckout) {
                if (this.debug) {
                    console.log("@isCheckout", this.address, this.checkout);
                    if (this.address.list.length <= 0) {
                        console.log(
                            "Attenzione lista indirizzi utente assente"
                        );
                    }
                }
                if (this.address.list.length <= 0) {
                    this.userDontHaveAddress = true;
                }
                if (this.address.list.length > 0) {
                    // If there is a paymentAddress set use it as default, otherwise use the first saved address
                    const paymentAddressId =
                        this.checkout.paymentAddress || this.address.list[0].id;
                    await window.Store.setAddress(paymentAddressId);
                }
                console.log("CART ", this.cart);
                await this.checkValidPayment(this.cart.list_valid);
                // GA4
                let products = [];
                console.log("CART ", this.cart);
                this.cart.items.forEach(element => {
                    products.push({
                        name: element["ga4"].name,
                        id: element["product_version"],
                        price: element["attributes"].price,
                        brand: "Pollini",
                        category: element["ga4"].category,
                        category2: element["ga4"].category2,
                        category3: element["ga4"].category3,
                        category4: element["ga4"].category4,
                        category5: element["ga4"].category5,
                        variant:
                            element["ga4"].color +
                            "|" +
                            element["attributes"].size,
                        quantity: element["quantity"]
                    });
                });
                window.dataLayer.push({
                    event: "checkout",
                    eventCategory: "Ecommerce",
                    eventAction: "Checkout",
                    eventID: window.EventTrackingPageId,
                    "x-fb-ck-fbc": window.fbc_cookie,
                    "x-fb-ck-fbp": window.fbp_cookie,
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: 1,
                                option: "paypal"
                            },
                            products: products
                        }
                    }
                });
            }
            this.loading = false;
            $("#shopping-bag").on("click", event => {
                event.preventDefault();
                event.stopPropagation();
                this.open();
            });
        }
    });

    return cartVue;
};

export default HeadCart;
